import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateQualificationRequest extends BaseUpdateRequest {
    name = '';
    description = '';
}